// extracted by mini-css-extract-plugin
module.exports = {"txtAria":"style_txtAria__gZnqH","icon":"style_icon__1_blJ"};